import { NextPageContext } from 'next'
import Router from 'next/router'

export interface NextRedirectOptions {
  to: string
  res?: NextPageContext['res']
  method: 'replace' | 'push'
}

export const nextRedirect = async ({ to, res, method }: NextRedirectOptions): Promise<any> => {
  if (typeof window === 'undefined' && res) {
    res.writeHead(302, { Location: to })
    res.end()
  } else {
    Router[method](to)
  }

  return new Promise(() => {})
}
